title: Klant|Klanten
fields:
  firstName: Voornaam
  insertions: Tussenvoegsel
  lastName: Achternaam
  email: E-mail
  birthdate: Geboortedatum
  phoneNumber: Telefoonnummer
  profilePicture: Profielfoto
  description: Beschrijving (optioneel)
labels:
  email: E-mail
  phone: Telefoon
  visits: "{count} bezoek|{count} bezoeken"
  noShows: "{count} no-show|{count} no-shows"
  noShow: "No-show"
  previousAppointment: Laatste behandeling
  nextAppointment: Volgende afspraak
  treatment: Behandeling|Behandelingen
  updatedAt: Laatst bijgewerkt
  at: om
  media: "{count} foto|{count} foto's"
  uploadFileTitle: Foto's toevoegen
  uploadFileSubtitle: Voeg foto's toe aan deze behandeling
  customerNotes: Algemene notities
tableHeadings:
  status: Status
  firstName: Voornaam
  lastName: Achternaam
  email: E-mail
  phoneNumber: Telefoonnummer
  birthdate: Geboortedatum
  note: Algemene notitie
tabHeadings:
  note: Notities
  timeline: Tijdlijn
actions:
  addNote: Notitie toevoegen
  editNote: Notitie bewerken
  addFile: Foto's toevoegen
  editFile: Foto's bewerken
  removeNoShow: Verwijder no-show
  addNoShow: Voeg no-show toe
  chooseFile: Kies bestand
  importCustomers: Importeer {count} klant|Importeer {count} klanten
messages:
  addNewCustomer: Voeg een nieuwe klant toe aan uw dossier.
  selectCustomer: Selecteer een klant om details te bekijken
  editCustomer: Pas de gegevens van de klant aan.
  remove: Klant verwijderen
  removeInfo: Weet je zeker dat je deze klant wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.
  noYetTreated: Nog niet behandeld
  noFutureAppointment: Geen volgende afspraak ingepland
  treatmentAtTime: "{name} behandeling om {from} - {to}"
  noTreatments: Nog geen behandelingen
  treatmentsWillAppearInTimeline: Behandelingen verschijnen hier in de tijdlijn
  noCustomerNotes: Nog geen algemene notities
  noPictures: Nog geen foto's
  noPicturesDescription: Voeg foto's toe om een visueel overzicht te behouden
  importPreview: Preview - {count} rij gevonden|Preview - {count} rijen gevonden
  totalValidateCustomers: "{count} van de {total} klanten is geldig en kan worden geïmporteerd.|{count} van de {total} klanten zijn geldig en kunnen worden geïmporteerd."
  invalidCustomerAreSkipped: Rijen met fouten worden overgeslagen.
  importSuccessful: Import geslaagd!
  importedNumberOfCustomers: "{count} klant is succesvol geïmporteerd|{count} klanten zijn succesvol geïmporteerd"
  checkingImportFile: Bezig met bestand uitlezen...
import:
  salonized:
    title: Salonized klanten importeren
    subtitle: Importeer je bestaande klanten uit Salonized
    dialogTitle: Kom je van Salonized af?
    instruction: Upload je Salonized klantenexport (Excel of CSV bestand)
